<template>
  <div class="message-container">
    <div class="message">
      <div class="header" v-if="header" v-html="parsedHeader"></div>
      <p v-if="parsedBody" v-html="parsedBody"></p>
      <div class="footer" v-if="buttons && buttons.buttons">
        <button class="button" v-for="button in buttons.buttons" @click.prevent="followButton(button)">
          {{ button.text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhatsappMessage',
  props: {
    components: Array,
    variables: Array
  },
  methods: {
    followButton(button) {
      if (button.type === 'URL') {
        window.open(button.url)
      }
    }
  },
  computed: {
    header() {
      return this.components.filter(component => {
        return component.type === 'HEADER'
      })[0] ?? null
    },
    body() {
      return this.components.filter(component => {
        return component.type === 'BODY'
      })[0] ?? null
    },

    parsedHeader() {
      let content = ''

      if (this.header) {
        content = this.header.text

        if (this.header.example?.header_text) {
          const variableOrder = this.header.example.header_text
          content = this.header.text

          for (let i = 0; i < variableOrder.length; i++) {
            let variableName = variableOrder[i];

            if (!this.variables.includes(variableName)) {
              variableName = `<i class="text-danger" title="Variável não existente">${variableName}</i>`
            }

            content = content.replace(`{{${i + 1}}`, `{${variableName}`)
          }
        }
      }

      return content
    },

    parsedBody() {
      let content = ''

      if (this.body) {
        content = this.body.text

        if (this.body.example?.body_text) {
          const variableOrder = this.body.example.body_text[0]
          content = this.body.text

          for (let i = 0; i < variableOrder.length; i++) {
            let variableName = variableOrder[i];

            if (!this.variables.includes(variableName)) {
              variableName = `<i class="text-danger" title="Variável não existente">${variableName}</i>`
            }

            content = content.replace(`{{${i + 1}}`, `{${variableName}`)
          }
        }
      }

      return content
    },
    buttons() {
      return this.components.filter(component => {
        return component.type === 'BUTTONS'
      })[0] ?? null
    }
  }
}
</script>

<style scoped>
.message-container {
  padding: 10px 20px;
  width: 300px;
  font-family: Arial, sans-serif;
  color: #222;
  border-radius: 7px;
  background: #e5dfd5;
  position: relative;
  margin: 10px 0;

  .message-container::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: 10px solid;
    border-color: #e5dfd5 transparent transparent #e5dfd5;
    left: -19px;
    top: 7px;
  }

  .message {
    background: #FFF;
    border-radius: 5px;
    display: flex;
    flex-flow: column;
    padding: 10px;
  }

  .header {
    flex: 1;
    margin-bottom: 5px;
    font-weight: bold;
  }

  .footer {
    display: flex;


    button {
      color: #56A1EB;
      background: #FFF;
      padding: 5px 10px;
      border: none;
      border-top: 1px solid #CCC;
      margin-top: 10px;
      display: inline-block;
      cursor: pointer;
      flex: fit-content;
    }
  }
}
</style>
